<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
   <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
          <tbody>
              <tr>
                  <td class="col-sm-12 no-right-padding no-left-padding">
                      <table formArrayName="packageForm" class="table table-inner table-condensed table-striped">
                          <tbody>
                              <tr>
                                <th role="columnheader" aria-label="Package DI">
                                  Package DI
                                </th>
                                <th role="columnheader" aria-label="Issuing Agency"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                                  Issuing Agency
                                </th>
                                <th role="columnheader" aria-label="Contains Package DI">
                                  Contains Package DI
                                </th>
                                <th role="columnheader" aria-label="Contains Package DI Issuing Agency"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                                  Contains Package DI Issuing Agency
                                </th>
                                <th role="columnheader" aria-label="Package Type"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase()
                                  || dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                                  Package Type
                                </th>
                                <th role="columnheader" aria-label="Package Status"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.SWISSDAMED.toLowerCase()">
                                  Package Status
                                </th>
                                <th role="columnheader" aria-label="Package Quantity">
                                  Package Quantity
                                </th>
                                <th role="columnheader" aria-label="Package Discontinued Date"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                                  Package Discontinued Date
                                </th>
                              </tr>
                              <ng-container *ngIf="packageForm?.controls?.length; else emptyTemplate8fields">
                              <tr formGroupName="{{i}}" *ngFor="let item of packageForm.controls; let i = index">
                                <td role="gridcell" aria-label="Cell of Package DI">
                                  <label controlName="packageDi"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Issuing Agency"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase()">
                                  <label controlName="packageAgency"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Contains Package DI">
                                  <label controlName="containingDI"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Contains Package DI Issuing Agency"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase()">
                                  <label controlName="containingAgency"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Package Type"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.CHINA.toLowerCase()
                                  || dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                                  <label controlName="packageType"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Package Status"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.EUDAMED.toLowerCase()">
                                  <label controlName="packageStatusValue"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Package Quantity">
                                  <label controlName="packageQty"></label>
                                </td>
                                <td role="gridcell" aria-label="Cell of Package Discontinued Date"
                                  *ngIf="dataScope.toLowerCase() === dataScopesEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopesEnum.BRAZIL.toLowerCase()">
                                  <label controlName="packageDiscontinuedDate"></label>
                                </td>
                              </tr>
                              </ng-container>
                          </tbody>
                      </table>

                  </td>
              </tr>


          </tbody>
      </table>
  </form>
  </div>
</div>
<ng-template #emptyTemplate8fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
